export const WizardYesNo = {
  Yes: 'yes',
  No: 'no'
}
